<slot />

<script>
    import createHistory from 'history/createBrowserHistory'

    window.customHistory = createHistory()
</script>